import UAParser from 'ua-parser-js';
import OT from '@opentok/client';


const latestSafariVersion = 13;
const approvedIOSVersion = 13;
const approvedAndroidVersion = 9;

const deviceSupportCheck = () => {
  const errors = [];

  const result = new UAParser().getResult();
  const device = result.device;
  const browser = result.browser;
  const os = result.os;

  if (!OT.checkSystemRequirements()) {
    errors.push('browser');
    return errors;
  }

  // モバイルからのアクセスの場合、ブラウザとOSをチェックする
  if (isMobile(device)) {
    if (!isApprovedIPhone(browser, os) && !isApprovedAndroid(browser, os)) {
      errors.push('browser');
      return errors;
    }
  } else {
    // PCからのアクセスの場合、ブラウザをチェックする
    if (!['Chrome', 'Firefox', 'Safari'].includes(browser.name)) {
      errors.push('browser');
      return errors;
    }

    // Safariの場合、ver.13以降でなければエラー
    if('Safari' === browser.name && parseFloat(browser.version) < latestSafariVersion) {
      errors.push('browser');
      return errors;
    }
  }

  return errors;
};

const isMobile = (device) => {
  return device.model || device.type || device.vendor
}

const isApprovedIPhone = (browser, os) => {
  return ['Mobile Safari'].includes(browser.name)
    && os.name === 'iOS' 
    && parseFloat(os.version) >= approvedIOSVersion;
}

const isApprovedAndroid = (browser, os) => {
  return ['Chrome'].includes(browser.name)
    && os.name === 'Android'
    && parseFloat(os.version) >= approvedAndroidVersion;
}

export default deviceSupportCheck;
